import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { ToastContainer, toast } from "react-toastify";
import "sweetalert2/src/sweetalert2.scss";
import Lightbox from "react-image-lightbox";

import {
  getRequest,
  postRequest,
  deleteRequest,
  putRequestForm,
  putRequest,
  postRequestForm,
} from "../../components/Common/Utils.js";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import axios from "axios";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Spinner,
  Badge,
  UncontrolledTooltip,
  Modal,
  Button,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { change } from "redux-form";
import { id } from "date-fns/locale";
import DeliveryAgents from "components/Modal/DeliveryAgents";

const filterObj = {
  first_name: "",
  last_name: "",
  gender: "",
  email: "",
  phone: "",
  country: "",
  nationality: "",
  bookingCode: "",
  bookingDate: "",
  agentEmail: "",
};

const WarehouseManagementList = (props) => {
  const [modal_center, setmodal_center] = useState(false);
  const [listdata, setListdata] = useState([]);
  const [assingDeliveryModalData, setAssingDeliveryData] = useState({});
  const [loader, setLoader] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [sort, setsort] = React.useState("");
  const [sortOrder, setsortOrder] = React.useState("desc");
  const [sortOrderId, setsortOrderId] = React.useState(null);
  const [currentFPage, setCurrentFPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [sizePerPageOrg, setSizePerPage] = useState(10);
  const [image, setImage] = React.useState("");
  const [openLightbox, setOpenLightBox] = React.useState(false);
  const [model, setModel] = useState(false);
  const [filter, setFilter] = useState({ ...filterObj });

  useEffect(() => {
    fetchList();
  }, [currentPage]);

  useEffect(() => {
    fetchList();
  }, [sort, sortOrder]);

  const handleTableChange = (type, { page, sizePerPage, searchText }) => {
    if (type === "pagination") {
      if (page != currentPage) {
        setCurrentPage(page);
        console.log("page", page);
      }
    }

    if (type === "search") {
      console.log("searchText", searchText);
    }
  };

  const handleDownload = () => {
    const downloadLink = document.createElement("a");
    downloadLink.href = image;
    downloadLink.download = "downloaded-image.jpg";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  function SNoFormatter(cellContent, row, i) {
    return <>{i + 1}</>;
  }

  const columns = [
    {
      text: "S.NO",
      formatter: SNoFormatter,
      sort: false,
    },
    {
      dataField: "name",
      text: "Warehouse Name",
      sort: false,
    },
    {
      dataField: "address",
      text: "Location",
      sort: false,
    },
    {
      dataField: "capacity",
      text: "Capacity",
      sort: false,
    },
    {
      dataField: "actions",
      text: "Action",
      formatter: iconFormatter2,
      sort: false,
    },
  ];
  const handleChange = (event) => {
    setSizePerPage(event.target.value);
    if (currentPage != 1) {
      setCurrentPage(1);
    } else {
      fetchList(null, event.target.value);
    }
  };

  const handlesortOrder = (event) => {
    setsortOrder(event.target.value);
  };
  const handleReload = () => {
    setSearchText("");
    fetchList();
  };

  function iconFormatter2(cellContent, row) {
    return (
      <div className="d-flex gap-2">
        <button type="button" className="btn btn-danger">
          <Link
            className="text-light"
            to={{
              pathname: `/warehouse-inventory/${row?._id}`,
              state: { row },
            }}
          >
            <i className="fal fa-edit text-light"></i>&nbsp;Inventory
          </Link>
        </button>

        <button type="button" className="btn btn-warning">
          <Link
            className="text-light"
            to={{
              pathname: `/warehouse-update/${row?._id}`,
              state: { row },
            }}
          >
            <i className="fal fa-edit text-light"></i>&nbsp;Edit
          </Link>
        </button>

        {/* <button
          type="button"
          className="btn btn-danger"
          onClick={() => handleDelete(row._id)}
        >
          <i className="fal fa-trash text-light"></i>&nbsp;Delete
        </button> */}
      </div>
    );
  }

  const handleDelete = async (warehouseId) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      setLoader(true);
      try {
        const payload = { warehouseId };

        const response = await postRequest(`/warehouse/remove`, payload);

        if (response.status) {
          toast.success(response.message);
          fetchList(); // Refresh list
        } else {
          toast.error(response.message || "Failed to delete warehouse");
        }
      } catch (error) {
        console.error("Error deleting warehouse:", error);
        toast.error("An error occurred while deleting the warehouse");
      } finally {
        setLoader(false);
      }
    }
  };

  const limit = 10;

  const fetchList = async (filterArgs = [], limit = null) => {
    setLoader(true);
    const payload = {
      limit: limit ? limit : sizePerPageOrg,
      page: currentPage,
      sortField: sort,
      sortOrder: sortOrder,
    };

    if (filterArgs?.length) {
      payload.filterArgs = filterArgs;
    } else {
      if (searchText) {
        payload.search = searchText;
      }
    }

    try {
      const response = await postRequest(`warehouse/list`, payload);
      const data = response?.data;

      if (!data) throw new Error("No data received");

      setTotalPage(data?.count);
      setCurrentFPage(currentPage);
      setListdata(data?.list || []);
    } catch (error) {
      // console.error("Failed to fetch data:", error);
    } finally {
      setLoader(false);
    }
  };

  const closeModalDeleveryAgent = () => {
    setModel(false);
  };

  const selectRow = (item) => {
    console.log({ item });
    setAssingDeliveryData({
      Image: item?.image,
      Title: item?.title,
      categoryId: item?._id,
      show: true,
    });
    deliveryAssingOrder(item?._id);
    setModel(false);
  };

  const deliveryAssingOrder = async (_id) => {
    console.log(currentPage);
    setLoader(true);
    const payload = {
      orderId: sortOrderId,
      deliveryAgentId: _id,
    };
    try {
      const response = await postRequest(
        `order/assign-to-delivery-agent`,
        payload
      );
      if (response?.status) {
        fetchList();
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Order successfully assigned to the delivery agent!",
          confirmButtonText: "OK",
          timer: 2000,
        });
      }
    } catch (error) {
      console.log("Failed to fetch data:", error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <React.Fragment>
        <ToastContainer />
        <Row>
          <div className="col-md-6">
            <div className="page-title-box">
              <h4>Warehouse Management</h4>

              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item active">Warehouse Management</li>
                : <li className="breadcrumb-item">Warehouse List</li>
              </ol>
            </div>
          </div>

          <div className="col-md-6 text-end">
            <Link to="/warehouse-create">
              {" "}
              <Button>
                {" "}
                <i class="fas fa-plus"></i> Create
              </Button>{" "}
            </Link>
            &nbsp;&nbsp;&nbsp;
          </div>
          <Col className="col-12">
            <Card>
              {loader ? (
                <CardBody style={{ height: "100px" }}>
                  <Spinner
                    color="info"
                    style={{
                      height: "4rem",
                      width: "4rem",
                      position: "absolute",
                      left: "50%",
                    }}
                  >
                    Loading...
                  </Spinner>
                </CardBody>
              ) : (
                <CardBody className="table-shorting">
                  {
                    <PaginationProvider
                      pagination={paginationFactory({
                        page: currentFPage,
                        sizePerPage: sizePerPageOrg,
                        totalSize: totalPage,
                        custom: true,
                      })}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <>
                          <ToolkitProvider
                            keyField="_id"
                            data={listdata}
                            columns={columns}
                          >
                            {(props) => (
                              <Row>
                                <Col className="col-lg-12 d-flex mb-3">
                                  <label className="mb-0 text-label">
                                    Page Size
                                  </label>

                                  <select
                                    value={sizePerPageOrg}
                                    onChange={handleChange}
                                    className="form-select"
                                    style={{ width: "7%" }}
                                  >
                                    <option value="10">10</option>

                                    <option value="20">20</option>

                                    <option value="50">50</option>
                                  </select>

                                  <label className="mb-0 text-label ms-3">
                                    Sort Order:
                                  </label>
                                  <select
                                    value={sortOrder}
                                    onChange={handlesortOrder}
                                    className="form-select"
                                    style={{ width: "10%" }}
                                  >
                                    <option value="asc"> Ascending</option>
                                    <option value="desc">Descending</option>
                                  </select>
                                  <div className="filter-item">
                                    <input
                                      type="search"
                                      placeholder="Search"
                                      value={searchText}
                                      class="form-control"
                                      onChange={(e) =>
                                        setSearchText(e.target.value)
                                      }
                                      style={{ width: "30%" }}
                                    />
                                    <button
                                      onClick={() => {
                                        fetchList();
                                      }}
                                      type="button"
                                      className="btn btn-primary mx-2"
                                    >
                                      Search
                                    </button>

                                    <button
                                      type="button"
                                      onClick={handleReload}
                                      className="btn btn-danger mx-2"
                                    >
                                      Reset
                                    </button>
                                  </div>
                                </Col>

                                <Col className="col-lg-12 text-end">
                                  <BootstrapTable
                                    onTableChange={handleTableChange}
                                    remote={true}
                                    classes="table-striped"
                                    {...props.baseProps}
                                    {...paginationTableProps}
                                  />
                                </Col>
                              </Row>
                            )}
                          </ToolkitProvider>

                          <Row>
                            <Col className="col-lg-12 text-end">
                              <div className="text-md-right">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}
                    </PaginationProvider>
                  }
                </CardBody>
              )}
            </Card>
          </Col>
        </Row>
        {openLightbox && (
          <>
            <Lightbox
              mainSrc={image}
              onCloseRequest={() => setOpenLightBox(false)}
              toolbarButtons={[
                <button
                  className="btn btn-primary"
                  key="download"
                  onClick={handleDownload}
                >
                  Download
                </button>,
              ]}
            />
          </>
        )}

        <DeliveryAgents
          show={model}
          closeModal={closeModalDeleveryAgent}
          selectRow={selectRow}
        />
      </React.Fragment>
    </>
  );
};

export default WarehouseManagementList;
